import React from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import ServiceBanner from '../sections/ServiceBanner/ServiceBanner';
import ServicesList from '../sections/ServiceList/ServicesList';

const Services = () => {
  const { serviceName } = useParams();

  return (
    <>
      <Navbar />
      <ServiceBanner serviceName={serviceName} />
      <ServicesList /> {/* 👈 New section with all services */}
      <Footer />
    </>
  );
};

export default Services;


